import { Toolbar } from "@mui/material";
import Card from "@mui/material/Card/Card";
import CardContent from "@mui/material/CardContent/CardContent";
import React from "react";
import hand from '../../assets/hand.png'
import { useAppSelector } from "../../store/hooks/hooks";
import Navbar from "../navbar/navbar";
import AttendanceContainer from "./attendanceContainer/attendanceContainer";
import './dashboard.scss'

const EmployerDashboard = () => {
    const userDetails = useAppSelector((state: any) => state.user.user.result)
    return (
        <>
            <Navbar></Navbar>
            <Toolbar/>
            <Card className="m-5 fadedown shadow">
                <CardContent>
                    <div className="align-items-start flex flex-row">
                        <h1 className="titleDashboard">Hi <span className="titleName">{userDetails.first_name}</span>,Good Morning</h1>
                        <img src={hand} className="imageHand m-2"></img>
                    </div>
                    <h2 className='employerSubtitle gray-color'>Welcome to placement portal.Please find below the interns at your firm.</h2>
                    <AttendanceContainer></AttendanceContainer>
                </CardContent>

            </Card>
        </>

    )
}
export default EmployerDashboard;